<template>
  <div class="weather">
    <!-- <div id="chart-bass">
      <div id="chart-bass-frame">
        <div class="info">
          <p class="ic-chart">
            累積気温
            <span>{{ dateStart }}〜 {{ dateEnd }}</span>
          </p>

          <span id="closeBtn"></span>
        </div>

        <div class="chart-container-canvas">
          <canvas id="chart-large"></canvas>
        </div>

        <p class="calBtn">期間を変更する</p>
      </div>
    </div> -->
    <div id="chart-container">
      <!-- <p class="chart-date">{{ dateStart }}〜 {{ dateEnd }}</p> -->

      <div id="chart-layoutx1">
        <div class="chart-area">
          <p class="ic-weather">天気</p>
          <table>
            <tr>
              <th
                v-for="(row, index) in weatherHistories"
                :key="index"
                :class="{
                  stoday: isToday(row.weather_time),
                  sunday: isSunday(row.weather_time),
                  saturday: isSaturday(row.weather_time),
                }"
              >
                {{ FormatDateTime(row.weather_time) }}
              </th>
            </tr>
            <tr>
              <td v-for="(row, index) in weatherHistories" :key="index">
                <span
                  v-if="row.weather_type === 'clear-day'"
                  class="ic-sun"
                ></span>
                <span
                  v-else-if="row.weather_type === 'clear-night'"
                  class="ic-sun"
                ></span>
                <span
                  v-else-if="row.weather_type === 'rain'"
                  class="ic-rain"
                ></span>
                <span
                  v-else-if="row.weather_type === 'snow'"
                  class="ic-snow"
                ></span>
                <span
                  v-else-if="row.weather_type === 'sleet'"
                  class="ic-rain"
                ></span>
                <span v-else class="ic-cloud"></span>
              </td>
            </tr>
            <tr>
              <td v-for="(row, index) in weatherHistories" :key="index">
                <span class="col-red">{{ row.temperature_high }}</span
                >&nbsp;/&nbsp;<span class="col-blue">{{
                  row.temperature_low
                }}</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="chart-area scroll">
          <p class="ic-weather">今日・明日の天気</p>
          <div class="weather-area">
            <table>
              <tr>
                <th
                  v-for="(row, index) in weatherTodayHistories"
                  :key="index"
                  :class="{
                    nowtime: isNowTime(row.weather_time),
                  }"
                  colspan="2"
                >
                  {{ FormatDateTimeHour(row.weather_time) }}
                </th>
              </tr>
              <tr>
                <td
                  v-for="(row, index) in weatherTodayHistories"
                  :key="index"
                  colspan="2"
                >
                  <span
                    v-if="row.weather_type === 'clear-day'"
                    class="ic-sun"
                  ></span>
                  <span
                    v-else-if="row.weather_type === 'rain'"
                    class="ic-rain"
                  ></span>
                  <span
                    v-else-if="row.weather_type === 'snow'"
                    class="ic-snow"
                  ></span>
                  <span v-else class="ic-cloud"></span>
                </td>
              </tr>
              <tr>
                <template v-for="(row, index) in weatherTodayHistories">
                  <td :key="index + 't'" class="td-value">
                    <span>{{ row.temperature }}</span>
                  </td>
                  <td :key="index + 'tu'" class="td-unit">
                    <span class="text-unit">℃</span>
                  </td>
                </template>
              </tr>
              <tr>
                <template v-for="(row, index) in weatherTodayHistories">
                  <td :key="index + 'p'" class="td-value">
                    <span>{{ row.precip_probability }}</span>
                  </td>
                  <td :key="index + 'pu'" class="td-unit">
                    <span class="text-unit">%</span>
                  </td>
                </template>
              </tr>
              <tr>
                <template v-for="(row, index) in weatherTodayHistories">
                  <td :key="index + 's'" class="td-value">
                    <span>{{ row.wind_speed }}</span>
                  </td>
                  <td :key="index + 'su'" class="td-unit">
                    <span class="text-unit">m/s</span>
                  </td>
                </template>
              </tr>
              <tr>
                <template v-for="(row, index) in weatherTodayHistories">
                  <td :key="index" colspan="2">
                    <span
                      class="ic-wind-deg"
                      :style="'transform:rotate(' + row.wind_bearing + 'deg)'"
                    ></span>
                  </td>
                </template>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div id="chart-layoutx3">
        <div class="chart-area">
          <p class="ic-thermo">平均気温</p>
          <LineChart
            class="chart-container-canvas"
            v-if="loadedTemp"
            :chartData="chartdataTemp"
            :options="optionsTemp"
          ></LineChart>
        </div>
        <div class="chart-area">
          <p class="ic-water-level">降水量</p>
          <LineChart
            class="chart-container-canvas"
            v-if="loadedWater"
            :chartData="chartdataWater"
            :options="optionsWater"
          ></LineChart>
        </div>
        <!-- <div class="chart-area">
          <p class="ic-windy">風速</p>
          <LineChart
            class="chart-container-canvas"
            v-if="loadedWindy"
            :chartData="chartdataWindy"
            :options="optionsWindy"
          ></LineChart>
        </div> -->
      </div>
      <div v-for="(row, index) in chartdataAccList" :key="index">
        <div v-if="isMobileAny()" id="chart-layoutx3">
          <div class="chart-area x2">
            <p class="ic-chart">累積気温({{ row.name }})</p>
            <LineChart
              class="chart-container-canvas"
              v-if="loadedAcc"
              :chartData="row.data"
              :options="row.opt"
            ></LineChart>
          </div>
          <div class="chart-area x2">
            <div class="dashboard">
              <div>
                <p class="ic-chart">累積気温({{ row.name }})</p>
                <span class="ic-chart-point">今日時点</span>
                <PieChart
                  :percent="row.thermo"
                  :pieName="'pieChart' + index"
                ></PieChart>
              </div>
            </div>
          </div>
        </div>
        <div v-else id="chart-layoutx2">
          <div class="chart-area x2">
            <p class="ic-chart">累積気温({{ row.name }})</p>
            <LineChart
              class="chart-container-canvas"
              v-if="loadedAcc"
              :chartData="row.data"
              :options="row.opt"
            ></LineChart>
          </div>
          <div class="chart-area x2">
            <div class="dashboard">
              <div>
                <p class="ic-chart">累積気温({{ row.name }})</p>
                <span class="ic-chart-point">今日時点</span>
                <PieChart
                  :percent="row.thermo"
                  :pieName="'pieChart' + index"
                ></PieChart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LineChart from "@/components/WeatherChartLine.vue";
import PieChart from "@/components/WeatherPieChart.vue";
import Loader from "@/mixins/loader";
import isMobile from "@/mixins/ismobile";
import BigNumber from "bignumber.js";

export default {
  mixins: [Loader, isMobile],

  components: {
    LineChart,
    PieChart,
  },
  data: () => ({
    weatherHistories: [],
    weatherTodayHistories: [],
    loadedTemp: false,
    chartdataTemp: null,
    optionsTemp: null,
    loadedWater: false,
    chartdataWater: null,
    optionsWater: null,
    loadedWindy: false,
    chartdataWindy: null,
    optionsWindy: null,
    loadedAcc: false,
    chartdataAccList: [],
    loadedThermo: false,
    chartdataThermo: 0,
    dateStart: "",
    dateEnd: "",
  }),

  mounted() {
    this.$emit("hideMap");
    if (this.isMobileAny()) {
      this.$emit("hideMenu");
    }
    this.loading(async () => {
      await this.RenderGraph();
    });
  },

  methods: {
    ...mapActions([
      "retrieveWeatherHistories",
      "retrieveAccumulation",
      "retrieveTodayWeatherHourlyHistories",
    ]),
    ...mapGetters([
      "getHistories",
      "getAccumulationList",
      "getHourlyHistories",
    ]),

    async RenderGraph() {
      let dt = new Date();
      let dt2 = new Date();
      // Web,スマホで取得範囲を変更する
      dt2.setDate(dt2.getDate() - 3);
      if (this.isMobileAny()) {
        dt.setDate(dt.getDate() + 3);
      } else {
        dt.setDate(dt.getDate() + 6);
      }
      const fromdt =
        dt2.getFullYear() +
        "-" +
        ("0" + (dt2.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + dt2.getDate()).slice(-2) +
        "T00:00:00+0900";
      const todt =
        dt.getFullYear() +
        "-" +
        ("0" + (dt.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + dt.getDate()).slice(-2) +
        "T00:00:00+0900";
      try {
        this.weatherHistories = [];
        this.weatherTodayHistories = [];

        let params = { from_datetime: fromdt, to_datetime: todt };
        await this.retrieveWeatherHistories(params);
        await this.retrieveTodayWeatherHourlyHistories();
        await this.retrieveAccumulation(params);

        const orgHistories = this.getHistories();
        // 昇順に並び替える
        for (var i = orgHistories.length - 1; i >= 0; i--) {
          this.weatherHistories.push(orgHistories[i]);
        }

        this.weatherTodayHistories = this.getHourlyHistories();
      } catch (error) {
        console.log(error);
      }

      this.loadedTemp = false;
      this.loadedWater = false;
      this.loadedWindy = false;
      this.loadedAcc = false;
      this.loadedThermo = false;

      this.RenderDate();
      this.RenderChartTemp();
      this.RenderChartWater();
      // this.RenderChartWindy();

      const accInfos = this.getAccumulationList();
      accInfos.forEach((el) => {
        this.RenderChartAcc(el);
      });
      this.loadedAcc = true;
    },
    RenderDate() {
      var today = new Date();
      var fromday = new Date();

      // Web,スマホで取得範囲を変更する
      fromday.setDate(fromday.getDate() - 3);
      if (this.isMobileAny()) {
        today.setDate(today.getDate() + 3);
      } else {
        today.setDate(today.getDate() + 6);
      }

      var weekDay = ["日", "月", "火", "水", "木", "金", "土"];
      this.dateEnd =
        today.getFullYear() +
        "/" +
        (today.getMonth() + 1) +
        "/" +
        today.getDate() +
        "（" +
        weekDay[today.getDay()] +
        "）";
      this.dateStart =
        fromday.getFullYear() +
        "/" +
        (fromday.getMonth() + 1) +
        "/" +
        fromday.getDate() +
        "（" +
        weekDay[fromday.getDay()] +
        "）";
    },

    RenderChartTemp() {
      this.chartdataTemp = {
        labels: [],
        datasets: [
          {
            label: "平均気温",
            data: [],
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(233, 30, 99, 0.5)",
            borderColor: "rgba(233, 30, 99, 0.7)",
          },
        ],
      };
      this.optionsTemp = {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: false,
          // display: true
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ ℃ ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                // beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
                // min: "8/3"
              },
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 30,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      };

      const list = this.getHistories();
      try {
        for (var i = 0, len = list.length - 1; i <= len; --len) {
          let dt = new Date(list[len].weather_time);

          this.chartdataTemp.labels.push(
            dt.getMonth() + 1 + "/" + dt.getDate()
          );
          this.chartdataTemp.datasets[0].data.push(list[len].temperature_ave);
        }
      } catch (error) {
        console.log(error);
      }
      this.loadedTemp = true;
    },

    RenderChartWater() {
      this.chartdataWater = {
        labels: [],
        datasets: [
          {
            label: "降水量",
            data: [],
            // borderColor: "#CFD8DC",
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(233, 30, 99, 0.5)",
            borderColor: "rgba(233, 30, 99, 0.7)",
          },
        ],
      };
      this.optionsWater = {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: false,
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ mm/h ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
              },
              // id: 'bar-axes-X',
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 30,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      };
      const list = this.getHistories();
      try {
        for (var i = 0, len = list.length - 1; i <= len; --len) {
          let dt = new Date(list[len].weather_time);

          this.chartdataWater.labels.push(
            dt.getMonth() + 1 + "/" + dt.getDate()
          );
          this.chartdataWater.datasets[0].data.push(list[len].precip_intensity);
        }
      } catch (error) {
        console.log(error);
      }
      this.loadedWater = true;
    },
    RenderChartWindy() {
      this.chartdataWindy = {
        labels: [],
        datasets: [
          {
            label: "風速",
            data: [],
            // borderColor: "#CFD8DC",
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(233, 30, 99, 0.5)",
            borderColor: "rgba(233, 30, 99, 0.7)",
          },
        ],
      };
      this.optionsWindy = {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: false,
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ m/s ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
              },
              // id: 'bar-axes-X',
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 30,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      };
      const list = this.getHistories();
      try {
        for (var i = 0, len = list.length - 1; i <= len; --len) {
          let dt = new Date(list[len].weather_time);

          this.chartdataWindy.labels.push(
            dt.getMonth() + 1 + "/" + dt.getDate()
          );
          this.chartdataWindy.datasets[0].data.push(list[len].wind_speed);
        }
      } catch (error) {
        console.log(error);
      }
      this.loadedWindy = true;
    },
    RenderChartAcc(accInfo) {
      let chartdataAcc = {
        labels: [],
        datasets: [
          {
            label: "累積気温",
            data: [],
            // borderColor: "#CFD8DC",
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(233, 30, 99, 0.5)",
            borderColor: "rgba(233, 30, 99, 0.7)",
          },
        ],
      };

      let optionsAcc = {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: false,
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ ℃ ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
                max: 0,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
              },
              // id: 'bar-axes-X',
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 30,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      };
      var sumVals = [];
      let thermo = 0;
      let name = "";

      try {
        if (accInfo.settings) {
          name = accInfo.settings.name;

          sumVals.push(accInfo.settings.sum);
          // 小数点誤差回避のため、100倍にしてroundを行い計算
          // let wksum = accInfo.settings.sum * 100;
          // wksum = Math.round(wksum);
          // const list = accInfo.histories;
          // for (var i = 0, len = list.length; i < len; ++i) {
          //   let wkave = list[i].temperature_ave * 100;
          //   wksum -= Math.round(wkave);
          //   sumVals.push(wksum / 100);
          // }
          let wksum = new BigNumber(accInfo.settings.sum);
          const list = accInfo.histories;
          for (var i = 0, len = list.length; i < len; ++i) {
            wksum = wksum.minus(list[i].temperature_ave);
            sumVals.push(wksum.toNumber());
          }
          for (i = 0, len = list.length - 1; i <= len; --len) {
            let dt = new Date(list[len].weather_time);

            chartdataAcc.labels.push(dt.getMonth() + 1 + "/" + dt.getDate());
            chartdataAcc.datasets[0].data.push(sumVals[len]);
          }
          optionsAcc.scales.yAxes[0].ticks.max = parseInt(
            accInfo.settings.target
          );
          if (accInfo.settings.percent) {
            thermo = accInfo.settings.percent;
          }
          if (thermo > 100) {
            thermo = 100;
          }
        }
      } catch (error) {
        console.log(error);
      }

      this.chartdataAccList.push({
        data: chartdataAcc,
        opt: optionsAcc,
        thermo: thermo,
        name: name,
      });
    },

    CreateXLabel(utcdate) {
      const iso = this.ConvertUTCtoISO(utcdate);
      return iso.getMonth() + 1 + "/" + iso.getDate();
    },

    ConvertUTCtoISO(utcdate) {
      return new Date(
        Date.UTC(
          utcdate.slice(0, 4),
          parseInt(utcdate.slice(5, 7)) - 1,
          parseInt(utcdate.slice(8, 10)),
          parseInt(utcdate.slice(11, 13))
        )
      );
    },

    FormatDateTime(src) {
      if (!src) {
        return;
      }
      var weekDay = ["日", "月", "火", "水", "木", "金", "土"];
      const date = new Date(src);
      return (
        date.getMonth() +
        1 +
        "/" +
        date.getDate() +
        "(" +
        weekDay[date.getDay()] +
        ")"
      );
    },
    FormatDateTimeHour(src) {
      if (!src) {
        return;
      }
      const date = new Date(src);
      return date.getHours() + ":00";
    },

    isToday(src) {
      const today = new Date();
      const date = new Date(src);

      return (
        today.getFullYear() === date.getFullYear() &&
        today.getMonth() === date.getMonth() &&
        today.getDate() === date.getDate()
      );
    },
    isSunday(src) {
      const date = new Date(src);
      return date.getDay() === 0;
    },
    isSaturday(src) {
      const date = new Date(src);
      return date.getDay() === 6;
    },
    isNowTime(src) {
      const today = new Date();
      const date = new Date(src);

      return (
        today.getDate() === date.getDate() &&
        today.getHours() === date.getHours()
      );
    },
  },
};
</script>

<style lang="scss">
.weather {
  #chart-container {
    width: 100%;
    // background: #ddd;
    // background: #ddd;
    padding: 0px 30px;
    box-sizing: border-box;

    .mobile & {
      padding: 50px 10px 10px 10px;
    }
  }
  .chart-container-canvas {
    position: relative;
    /* width: 100%; */
    height: 250px;
  }
  .chart-date {
    font-weight: normal;
    font-size: 22px;
    margin: 0;
    padding: 0 0 30px 0;

    .mobile & {
      font-size: 16px;
      padding: 20px 0 10px 0;
    }
  }
  .chart-date::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_cal.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 0 28px 0 0;

    .mobile & {
      background-size: 25px 25px;
      padding: 10px 25px 10px 10px;
    }
  }
  #chart-layoutx1 {
    display: grid;
    grid-template-columns: auto;
    width: 100%;
    box-sizing: border-box;
  }

  #chart-layoutx2 {
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(400px, 2fr) minmax(350px, 1fr)
    );
    width: 100%;
    // justify-content: space-around;
    box-sizing: border-box;
  }

  #chart-layoutx3 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    width: 100%;
    box-sizing: border-box;
  }

  .chart-area {
    height: auto;
    min-height: 180px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 0px 20px 5px rgb(0 0 0 / 0.1);
    padding: 20px;
    margin: 15px;
    box-sizing: border-box;
    // cursor: pointer;

    &.scroll {
      overflow-x: scroll;
    }
  }

  .chart-area p {
    margin: 0;
    padding: 0;
    font-size: 20px;

    .mobile & {
      font-size: 16px;
    }
  }
  .dashboard {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, max-content));
    justify-content: space-around;
    row-gap: 20px;
    column-gap: 50px;

    .ic-chart-point {
      display: block;
      box-sizing: border-box;
      text-align: center;
      color: #666;

      .mobile & {
        font-size: 14px;
      }
    }
  }
  .dashboard div {
    display: block;
    // width: 180px;
    box-sizing: border-box;
    position: relative;
  }
  .dashboard p {
    text-align: center;
    color: #000;
  }
  .weather-area {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;

    table {
      margin: 20px auto 5px;
      width: 100%;
      border-bottom: solid 1px #ddd;
      background: #fff;
    }
    th {
      padding: 2px;
      border-bottom: solid 1px #bbb;
      background: #ddd;
      font-weight: normal;
      // width: 10%;
      min-width: 80px;
      padding: 2px 10px;
    }

    // th:nth-child(0) {
    //   border-right: none;
    // }

    td {
      padding: 2px;
      text-align: center;
      border-bottom: solid 1px #ddd;
    }

    // td:nth-child(0) {
    //   border-right: none;
    // }

    .td-value {
      width: 50%;
      text-align: right;
    }
    .td-unit {
      width: 50%;
      text-align: left;
    }
    .text-unit {
      font-size: 14px;
    }

    .nowtime {
      background: #fff7b4;
    }
  }

  // ul {
  //   margin: 0;
  //   padding: 0;
  // }
  // .pieChart {
  //   display: block;
  //   width: 200px; // 180
  //   height: 220px; // 220
  //   margin: 10px auto 0;
  //   position: relative;
  //   box-sizing: border-box;
  //   // padding-top: 100px;
  //   padding-top: 120px;
  //   text-align: center;
  //   color: #fdab57;
  //   font-size: 20px;

  //   .mobile & {
  //     width: 180px;
  //   }
  // }
  // .pieChart span {
  //   display: block;
  //   font-size: 56px;
  //   font-weight: 500;
  //   color: #fdab57;
  //   position: absolute;
  //   // top: 60%;
  //   top: 45%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);

  //   .mobile & {
  //     font-size: 50px;
  //   }
  // }
  // .pieChart canvas {
  //   position: absolute;
  //   // top: 65%;
  //   top: 55%;
  //   left: 50%;
  //   transform: translate(-50%, -55%);
  // }
  table {
    margin: 20px auto 5px;
    width: 100%;
    // border: solid 1px #ddd;
    border-bottom: solid 1px #ddd;
    // font-size: 0.9rem;
    background: #fff;
    /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */

    .mobile & {
      font-size: 12px;
    }
  }
  th {
    padding: 2px;
    border-bottom: solid 1px #bbb;
    // border-right: solid 1px #bbb;
    background: #ddd;
    font-weight: normal;
    width: 10%;
  }

  th:nth-child(0) {
    border-right: none;
  }

  td {
    padding: 2px;
    text-align: center;
    border-bottom: solid 1px #ddd;
    // border-right: solid 1px #ddd;
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }

  .stoday {
    background: #fff7b4;
  }
  .sunday {
    color: #e23333;
  }
  .saturday {
    color: #1a82b7;
  }

  /* チャート拡大 */

  #chart-bass {
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    background: rgba(0, 0, 0, 0.9);
    width: 100%;
    height: 100vh;
    z-index: 3;
    padding: 60px;
  }
  #chart-bass-frame {
    width: 100%;
    height: 100%;
    padding: 30px;
    border-radius: 20px;
    background: #fff;
  }

  #chart-bass-frame .info {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: top;
  }

  #chart-bass-frame .info p {
    font-size: 20px;
    margin: 0;
    padding: 0 0 20px 15px;
  }

  #chart-bass-frame .info span {
    font-size: 18px;
    margin: 0;
    padding: 0 0 0 20px;
  }

  #closeBtn {
    display: block;
    width: 30px;
    height: 30px;
    background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
    background-size: 30px 30px;
    cursor: pointer;
    transition: 0.1s;
  }
  #closeBtn:active {
    transform: scale(0.9);
    opacity: 0.8;
  }

  #chart-bass.active {
    display: block;
    animation: showChart 0.3s ease 0s;
  }

  #chart-bass .chart-container-canvas {
    position: relative;
    /* width: 100%; */
    height: 80%;
  }

  #chart-bass .calBtn {
    display: block;
    margin: 30px 20px;
    text-align: right;
    color: black;
    cursor: pointer;
    font-size: 14px;
    transition: 0.5s;
  }

  #chart-bass .calBtn::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_cal.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 13px 0 0;
  }

  #chart-bass .calBtn:hover {
    color: #666;
  }

  @keyframes showChart {
    from {
      transform: scale(0.5);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  /* アイコン */

  .ic-chart {
    display: block;
  }
  .ic-chart::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_chart.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 15px;

    .mobile & {
      background-size: 25px 25px;
      padding: 10px;
    }
  }

  .ic-weather {
    display: block;
  }
  .ic-weather::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/wi_sunny_title.svg") no-repeat center
      center;
    background-size: 28px 28px;
    padding: 15px;

    .mobile & {
      background-size: 25px 25px;
      padding: 10px;
    }
  }

  .ic-thermo {
    display: block;
  }
  .ic-thermo::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_thermometer.sun.svg") no-repeat center
      center;
    background-size: 28px 28px;
    padding: 10px;

    .mobile & {
      background-size: 25px 25px;
      padding: 10px;
    }
  }

  .ic-water-level {
    display: block;
  }
  .ic-water-level::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_rain.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 10px;

    .mobile & {
      background-size: 25px 25px;
      padding: 10px;
    }
  }

  .ic-sunny {
    display: block;
  }
  .ic-sunny::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_sunny.svg") no-repeat center center;
    background-size: 35px 35px;
    padding: 10px;
  }

  .ic-water-temp {
    display: block;
  }
  .ic-water-temp::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_thermometer.svg") no-repeat center
      center;
    background-size: 35px 35px;
    padding: 10px;
  }

  .ic-water {
    display: block;
  }
  .ic-water::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_water_level.svg") no-repeat center
      center;
    background-size: 30px 30px;
    padding: 10px;
  }
  .ic-windy {
    display: block;
  }
  .ic-windy::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_strong_wind.svg") no-repeat center
      center;
    background-size: 30px 30px;
    padding: 10px;
  }

  .ic-sun {
    background: url("~@/assets/icons/wi_sunny.svg") no-repeat center center;
    background-size: 30px 30px;
    height: 40px;
    display: block;

    .mobile & {
      background-size: 25px 25px;
    }
  }
  .ic-cloud-sun {
    background: url("~@/assets/icons/wi_cloud_sunny.svg") no-repeat center
      center;
    background-size: 30px 30px;
    height: 40px;
    display: block;

    .mobile & {
      background-size: 25px 25px;
    }
  }
  .ic-cloud {
    background: url("~@/assets/icons/wi_cloud.svg") no-repeat center center;
    background-size: 30px 30px;
    height: 40px;
    display: block;

    .mobile & {
      background-size: 25px 25px;
    }
  }
  .ic-rain {
    background: url("~@/assets/icons/wi_rain.svg") no-repeat center center;
    background-size: 30px 30px;
    height: 40px;
    display: block;

    .mobile & {
      background-size: 25px 25px;
    }
  }
  .ic-snow {
    background: url("~@/assets/icons/wi_snow.svg") no-repeat center center;
    background-size: 30px 30px;
    height: 40px;
    display: block;

    .mobile & {
      background-size: 25px 25px;
    }
  }
  .ic-wind-deg {
    background: url("~@/assets/icons/ic-wind-deg.svg") no-repeat center center;
    background-size: 20px 20px;
    height: 30px;
    display: block;
  }

  .col-red {
    color: var(--col1);
  }
  .col-blue {
    color: var(--col3);
  }
}
</style>
